/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 0 = None
 * 1 = Orange
 * 2 = Blue
 * 3 = Darkblue
 */
export enum DataThemes {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
}
